/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from 'axios'

Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'


// Algolia - Instant Search
// import InstantSearch from 'vue-instantsearch';

// Vue.use(InstantSearch);


// Firebase
// import '@/configs/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";

Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Clipboard
// import VueClipboard from 'vue-clipboard2'

// Vue.use(VueClipboard);


// Tour
// import VueTour from 'vue-tour'

// Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
VeeValidate.Validator.extend('verify_password', {
    getMessage: () => `The password length at least 8 digits and contain at least one uppercase, one lowercase and number.`,
    validate: value => {
        let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})")
        return strongRegex.test(value)
    }
})


// Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'

// Vue.use(VueGoogleMaps, {
    // load: {
        // Add your API key here
//         key: 'API_KEY',
//         libraries: 'places', // This is required if you use the Auto complete plug-in
//     },
// })

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// APM Elastic 

import { ApmVuePlugin } from "@elastic/apm-rum-vue";

Vue.use(ApmVuePlugin, {
    router,
    config: {
        serviceName: process.env.VUE_APP_ELASTIC_APM_SERVICE_NAME,
        // secretToken: process.env.VUE_APP_ELASTIC_APM_SECRET_TOKEN,
        serverUrl: process.env.VUE_APP_ELASTIC_APM_SERVER_URL,
        environment: process.env.VUE_APP_ELASTIC_APM_ENVIRONMENT,
    },
});


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

Vue.mixin({
    data:function () {
        return {
            get hostMqtt(){
                return process.env.VUE_APP_MQTT_HOST
            },
            get portMqtt(){
                return parseInt(process.env.VUE_APP_MQTT_PORT)
            },
            get mqttUsername(){
                return process.env.VUE_APP_MQTT_USERNAME
            },
            get mqttPassword(){
                return process.env.VUE_APP_MQTT_PASSWORD
            },
            get mqttUseSSL(){
                switch(process.env.VUE_APP_MQTT_USE_SSL){
                    case 'true':
                        return true
                    default :
                        return false
                }
            }
        }
    }
})

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
